import { authFetch } from "./authClient";

export async function startCheckout(plan: "personal" | "team"): Promise<void> {
  const successUrl = `${window.location.origin}?billing=success`;
  const cancelUrl = `${window.location.origin}?billing=cancelled`;

  const res = await authFetch("/billing/checkout", {
    method: "POST",
    body: JSON.stringify({ plan, successUrl, cancelUrl }),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || "Failed to start Mollie checkout");
  }
  const { url } = (await res.json()) as { url: string };
  window.location.href = url;
}

export async function cancelSubscription(): Promise<void> {
  const res = await authFetch("/billing/cancel", {
    method: "POST",
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || "Failed to cancel subscription");
  }
}
